import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { ConfigService } from '../core/services/config.service';

@Pipe({
    name: 'shortDate'
})
export class ShortDatePipe implements PipeTransform {
    transform(date: any, args?: any): any {
        const d = Date.parse(date);
        if (isNaN(d)) {
            return '';
        } return moment(d).format(ConfigService.shortTimeFormat);

    }
}
